/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Access_Stripe_DashboardInputs */

const en_access_stripe_dashboard = /** @type {(inputs: Access_Stripe_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access Stripe Dashboard`)
};

const es_access_stripe_dashboard = /** @type {(inputs: Access_Stripe_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceder al panel de Stripe`)
};

const fr_access_stripe_dashboard = /** @type {(inputs: Access_Stripe_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accéder au tableau de bord Stripe`)
};

const de_access_stripe_dashboard = /** @type {(inputs: Access_Stripe_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf Stripe-Dashboard zugreifen`)
};

const ja_access_stripe_dashboard = /** @type {(inputs: Access_Stripe_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripeダッシュボードにアクセス`)
};

const zh_access_stripe_dashboard = /** @type {(inputs: Access_Stripe_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`访问 Stripe 仪表板`)
};

const ar_access_stripe_dashboard = /** @type {(inputs: Access_Stripe_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الوصول إلى لوحة تحكم Stripe`)
};

const id_access_stripe_dashboard = /** @type {(inputs: Access_Stripe_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akses Dasbor Stripe`)
};

const it_access_stripe_dashboard = /** @type {(inputs: Access_Stripe_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi alla Dashboard Stripe`)
};

const ru_access_stripe_dashboard = /** @type {(inputs: Access_Stripe_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступ в панель управления Stripe`)
};

const pt_access_stripe_dashboard = /** @type {(inputs: Access_Stripe_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acessar Painel do Stripe`)
};

const ko_access_stripe_dashboard = /** @type {(inputs: Access_Stripe_DashboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe 대시보드 접속`)
};

/**
* | output |
* | --- |
* | "Access Stripe Dashboard" |
*
* @param {Access_Stripe_DashboardInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const access_stripe_dashboard = /** @type {((inputs?: Access_Stripe_DashboardInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Access_Stripe_DashboardInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_access_stripe_dashboard(inputs)
	if (locale === "es") return es_access_stripe_dashboard(inputs)
	if (locale === "fr") return fr_access_stripe_dashboard(inputs)
	if (locale === "de") return de_access_stripe_dashboard(inputs)
	if (locale === "ja") return ja_access_stripe_dashboard(inputs)
	if (locale === "zh") return zh_access_stripe_dashboard(inputs)
	if (locale === "ar") return ar_access_stripe_dashboard(inputs)
	if (locale === "id") return id_access_stripe_dashboard(inputs)
	if (locale === "it") return it_access_stripe_dashboard(inputs)
	if (locale === "ru") return ru_access_stripe_dashboard(inputs)
	if (locale === "pt") return pt_access_stripe_dashboard(inputs)
	return ko_access_stripe_dashboard(inputs)
});